module.exports = __webpack_public_path__ + "woff/OpenSans-CondLight-webfont.b01901.woff";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/assets/fonts/OpenSans-CondLight-webfont.woff
 ** module id = 318
 ** module chunks = 12
 **/